import { defineComponent as _defineComponent } from 'vue';
import { DialogRoot, useForwardPropsEmits } from "reka-ui";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Sheet',
    props: {
        open: { type: Boolean, required: false },
        defaultOpen: { type: Boolean, required: false },
        modal: { type: Boolean, required: false },
        unmountOnHide: { type: Boolean, required: false }
    },
    emits: ["update:open"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const forwarded = useForwardPropsEmits(props, emits);
        const __returned__ = { props, emits, forwarded, get DialogRoot() { return DialogRoot; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
